import { render, staticRenderFns } from "./LocaleFieldButton.vue?vue&type=template&id=21a0306f"
import script from "./LocaleFieldButton.vue?vue&type=script&lang=js"
export * from "./LocaleFieldButton.vue?vue&type=script&lang=js"
import style0 from "./LocaleFieldButton.vue?vue&type=style&index=0&id=21a0306f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports